/* oxlint-disable max-lines */
// mapping of records onto corresponding Vuex store attributes in module
import { RECORD_TYPE } from '@/app/data/model_constants';

const RESOURCES = Object.freeze({
  [RECORD_TYPE.AI_CHAT]: {
    record_type: RECORD_TYPE.AI_CHAT,
    store_attr: 'ai_chats',
    store_module: 'ai_chats',
  },
  [RECORD_TYPE.AI_CHAT_STAT]: {
    record_type: RECORD_TYPE.AI_CHAT_STAT,
    store_attr: 'ai_chat_stats',
    store_module: 'ai_chat_stats',
  },
  [RECORD_TYPE.AI_STAT]: {
    record_type: RECORD_TYPE.AI_STAT,
    store_attr: 'ai_stats',
    store_module: 'ai_stats',
  },
  [RECORD_TYPE.AI_MESSAGE]: {
    record_type: RECORD_TYPE.AI_MESSAGE,
    store_attr: 'ai_messages',
    store_module: 'ai_messages',
  },
  [RECORD_TYPE.ATTACHMENT]: {
    record_type: RECORD_TYPE.ATTACHMENT,
    store_attr: 'attachments',
    store_module: 'attachments',
  },
  [RECORD_TYPE.ATTACHMENT_CATEGORY]: {
    record_type: RECORD_TYPE.ATTACHMENT_CATEGORY,
    store_attr: 'attachment_categories',
    store_module: 'attachment_categories',
  },
  [RECORD_TYPE.ATTACHMENT_TEMPLATE]: {
    record_type: RECORD_TYPE.ATTACHMENT_TEMPLATE,
    store_attr: 'attachment_templates',
    store_module: 'attachment_templates',
  },
  [RECORD_TYPE.ACTIVITY]: {
    record_type: RECORD_TYPE.ACTIVITY,
    store_attr: 'activities',
    store_module: 'activities',
  },
  [RECORD_TYPE.ANNOUNCEMENT]: {
    record_type: RECORD_TYPE.ANNOUNCEMENT,
    store_attr: 'announcements',
    store_module: 'announcements',
    is_paginated: true,
  },
  [RECORD_TYPE.ASSIGNMENT]: {
    record_type: RECORD_TYPE.ASSIGNMENT,
    store_attr: 'assignments',
    store_module: 'assignments',
  },
  [RECORD_TYPE.BILLING]: {
    record_type: RECORD_TYPE.BILLING,
    store_attr: 'billings',
    store_module: 'billings',
  },
  [RECORD_TYPE.BUILDING]: {
    record_type: RECORD_TYPE.BUILDING,
    store_attr: 'buildings',
    store_module: 'buildings',
  },
  [RECORD_TYPE.BUNDLE]: {
    record_type: RECORD_TYPE.BUNDLE,
    store_attr: 'bundles',
    store_module: 'bundles',
  },
  [RECORD_TYPE.CHOICE]: {
    record_type: RECORD_TYPE.CHOICE,
    store_attr: 'choices',
    store_module: 'choices',
  },
  [RECORD_TYPE.CHOICE_TEMPLATE]: {
    record_type: RECORD_TYPE.CHOICE_TEMPLATE,
    store_attr: 'choice_templates',
    store_module: 'choice_templates',
  },
  [RECORD_TYPE.CHOICE_LIST]: {
    record_type: RECORD_TYPE.CHOICE_LIST,
    store_attr: 'choice_lists',
    store_module: 'choice_lists',
  },
  [RECORD_TYPE.CHOICE_LIST_TEMPLATE]: {
    record_type: RECORD_TYPE.CHOICE_LIST_TEMPLATE,
    store_attr: 'choice_list_templates',
    store_module: 'choice_list_templates',
  },
  [RECORD_TYPE.CLIENT]: {
    record_type: RECORD_TYPE.CLIENT,
    store_attr: 'clients',
    store_module: 'clients',
  },
  [RECORD_TYPE.CLIENT_FEATURE_EXCEPTION]: {
    record_type: RECORD_TYPE.CLIENT_FEATURE_EXCEPTION,
    store_attr: 'client_feature_exceptions',
    store_module: 'client_feature_exceptions',
  },
  [RECORD_TYPE.CUSTOMER]: {
    record_type: RECORD_TYPE.CUSTOMER,
    store_attr: 'customers',
    store_module: 'customers',
  },
  [RECORD_TYPE.CUSTOMER_GROUP]: {
    record_type: RECORD_TYPE.CUSTOMER_GROUP,
    store_attr: 'customer_groups',
    store_module: 'customer_groups',
  },
  [RECORD_TYPE.DEAL]: {
    record_type: RECORD_TYPE.DEAL,
    store_attr: 'deals',
    store_module: 'deals',
  },
  [RECORD_TYPE.DOCUMENT]: {
    record_type: RECORD_TYPE.DOCUMENT,
    store_attr: 'documents',
    store_module: 'documents',
    is_paginated: true,
  },
  [RECORD_TYPE.DOCUMENT_TEMPLATE]: {
    record_type: RECORD_TYPE.DOCUMENT_TEMPLATE,
    store_attr: 'document_templates',
    store_module: 'document_templates',
  },
  [RECORD_TYPE.DECISION]: {
    record_type: RECORD_TYPE.DECISION,
    store_attr: 'decisions',
    store_module: 'decisions',
  },
  [RECORD_TYPE.FEATURE_TOGGLE]: {
    record_type: RECORD_TYPE.FEATURE_TOGGLE,
    store_attr: 'feature_toggles',
    store_module: 'feature_toggles',
    namespace: 'shared',
  },
  [RECORD_TYPE.FOLLOW]: {
    record_type: RECORD_TYPE.FOLLOW,
    store_attr: 'follows',
    store_module: 'follows',
  },
  [RECORD_TYPE.SURVEY]: {
    record_type: RECORD_TYPE.SURVEY,
    store_attr: 'surveys',
    store_module: 'surveys',
  },
  [RECORD_TYPE.SIGNATURE]: {
    record_type: RECORD_TYPE.SIGNATURE,
    store_attr: 'signatures',
    store_module: 'signatures',
  },
  [RECORD_TYPE.SIGNATURE_TEMPLATE]: {
    record_type: RECORD_TYPE.SIGNATURE_TEMPLATE,
    store_attr: 'signature_templates',
    store_module: 'signature_templates',
  },
  [RECORD_TYPE.PARTNER_GROUP]: {
    record_type: RECORD_TYPE.PARTNER_GROUP,
    store_attr: 'partner_groups',
    store_module: 'partner_groups',
  },
  [RECORD_TYPE.PROFESSIONAL_SERVICE]: {
    record_type: RECORD_TYPE.PROFESSIONAL_SERVICE,
    store_attr: 'professional_services',
    store_module: 'professional_services',
  },
  [RECORD_TYPE.GROUP_CUSTOMER]: {
    record_type: RECORD_TYPE.GROUP_CUSTOMER,
    store_attr: 'group_customers',
    store_module: 'group_customers',
  },
  [RECORD_TYPE.GROUP_PARTNER]: {
    record_type: RECORD_TYPE.GROUP_PARTNER,
    store_attr: 'group_partners',
    store_module: 'group_partners',
  },
  [RECORD_TYPE.GROUP_LEAD]: {
    record_type: RECORD_TYPE.GROUP_LEAD,
    store_attr: 'group_leads',
    store_module: 'group_leads',
  },
  [RECORD_TYPE.DECISION_PROPOSAL]: {
    record_type: RECORD_TYPE.DECISION_PROPOSAL,
    store_attr: 'decision_proposals',
    store_module: 'decision_proposals',
  },
  [RECORD_TYPE.DECISION_PROPOSAL_TEMPLATE]: {
    record_type: RECORD_TYPE.DECISION_PROPOSAL_TEMPLATE,
    store_attr: 'decision_proposal_templates',
    store_module: 'decision_proposal_templates',
  },
  [RECORD_TYPE.DECISION_TYPE]: {
    record_type: RECORD_TYPE.DECISION_TYPE,
    store_attr: 'decision_types',
    store_module: 'decision_types',
  },
  [RECORD_TYPE.DECISION_TYPE_CATEGORY]: {
    record_type: RECORD_TYPE.DECISION_TYPE_CATEGORY,
    store_attr: 'decision_type_categories',
    store_module: 'decision_type_categories',
  },
  [RECORD_TYPE.INSTALLMENT]: {
    record_type: RECORD_TYPE.INSTALLMENT,
    store_attr: 'installments',
    store_module: 'installments',
  },
  [RECORD_TYPE.FRACTION]: {
    record_type: RECORD_TYPE.FRACTION,
    store_attr: 'fractions',
    store_module: 'fractions',
  },
  [RECORD_TYPE.FRACTION_CATEGORY]: {
    record_type: RECORD_TYPE.FRACTION_CATEGORY,
    store_attr: 'fraction_categories',
    store_module: 'fraction_categories',
  },
  [RECORD_TYPE.ISSUE]: {
    record_type: RECORD_TYPE.ISSUE,
    store_attr: 'issues',
    store_module: 'issues',
  },
  [RECORD_TYPE.ISSUE_CATEGORY]: {
    record_type: RECORD_TYPE.ISSUE_CATEGORY,
    store_attr: 'issue_categories',
    store_module: 'issue_categories',
  },
  [RECORD_TYPE.ISSUE_LIST_TYPE]: {
    record_type: RECORD_TYPE.ISSUE_LIST_TYPE,
    store_attr: 'issue_list_types',
    store_module: 'issue_list_types',
  },
  [RECORD_TYPE.ISSUE_LIST]: {
    record_type: RECORD_TYPE.ISSUE_LIST,
    store_attr: 'issue_lists',
    store_module: 'issue_lists',
  },
  [RECORD_TYPE.ISSUE_STATUS]: {
    record_type: RECORD_TYPE.ISSUE_STATUS,
    store_attr: 'issue_statuses',
    store_module: 'issue_statuses',
  },
  [RECORD_TYPE.LEAD]: {
    record_type: RECORD_TYPE.LEAD,
    store_attr: 'leads',
    store_module: 'leads',
  },
  [RECORD_TYPE.LEAD_GROUP]: {
    record_type: RECORD_TYPE.LEAD_GROUP,
    store_attr: 'lead_groups',
    store_module: 'lead_groups',
  },
  [RECORD_TYPE.SNIPPET]: {
    record_type: RECORD_TYPE.SNIPPET,
    store_attr: 'snippets',
    store_module: 'snippets',
  },
  [RECORD_TYPE.SURVEY_TYPE]: {
    record_type: RECORD_TYPE.SURVEY_TYPE,
    store_attr: 'survey_types',
    store_module: 'survey_types',
  },
  [RECORD_TYPE.SURVEY]: {
    record_type: RECORD_TYPE.SURVEY,
    store_attr: 'surveys',
    store_module: 'surveys',
  },
  [RECORD_TYPE.SURVEY_ANSWER]: {
    record_type: RECORD_TYPE.SURVEY_ANSWER,
    store_attr: 'survey_answers',
    store_module: 'survey_answers',
  },
  [RECORD_TYPE.SURVEY_QUESTION]: {
    record_type: RECORD_TYPE.SURVEY_QUESTION,
    store_attr: 'survey_questions',
    store_module: 'survey_questions',
  },
  [RECORD_TYPE.EMAIL]: {
    record_type: RECORD_TYPE.EMAIL,
    store_attr: 'emails',
    store_module: 'emails',
  },
  [RECORD_TYPE.EMAIL_EVENT]: {
    record_type: RECORD_TYPE.EMAIL_EVENT,
    store_attr: 'email_events',
    store_module: 'email_events',
  },
  [RECORD_TYPE.EMAIL_BOUNCE]: {
    record_type: RECORD_TYPE.EMAIL_BOUNCE,
    store_attr: 'email_bounces',
    store_module: 'email_bounces',
  },
  [RECORD_TYPE.EMAIL_CLICK]: {
    record_type: RECORD_TYPE.EMAIL_CLICK,
    store_attr: 'email_clicks',
    store_module: 'email_clicks',
  },
  [RECORD_TYPE.EMAIL_DELIVERY]: {
    record_type: RECORD_TYPE.EMAIL_DELIVERY,
    store_attr: 'email_deliveries',
    store_module: 'email_deliveries',
  },
  [RECORD_TYPE.EMAIL_OPEN]: {
    record_type: RECORD_TYPE.EMAIL_OPEN,
    store_attr: 'email_opens',
    store_module: 'email_opens',
  },
  [RECORD_TYPE.EMAIL_SPAM]: {
    record_type: RECORD_TYPE.EMAIL_SPAM,
    store_attr: 'email_spams',
    store_module: 'email_spams',
  },
  [RECORD_TYPE.EMAIL_CONVERSATION]: {
    record_type: RECORD_TYPE.EMAIL_CONVERSATION,
    store_attr: 'email_conversations',
    store_module: 'email_conversations',
  },
  [RECORD_TYPE.EMPLOYEE_PROJECT]: {
    record_type: RECORD_TYPE.EMPLOYEE_PROJECT,
    store_attr: 'employee_projects',
    store_module: 'employee_projects',
  },
  [RECORD_TYPE.EMPLOYEE]: {
    record_type: RECORD_TYPE.EMPLOYEE,
    store_attr: 'employees',
    store_module: 'employees',
  },
  [RECORD_TYPE.EXPORT]: {
    record_type: RECORD_TYPE.EXPORT,
    store_attr: 'exports',
    store_module: 'exports',
  },
  [RECORD_TYPE.INTEGRATION]: {
    record_type: RECORD_TYPE.INTEGRATION,
    store_attr: 'integrations',
    store_module: 'integrations',
  },
  [RECORD_TYPE.INSPIRATION]: {
    record_type: RECORD_TYPE.INSPIRATION,
    store_attr: 'inspirations',
    store_module: 'inspirations',
  },
  [RECORD_TYPE.INSPIRATION_LIST]: {
    record_type: RECORD_TYPE.INSPIRATION_LIST,
    store_attr: 'inspiration_lists',
    store_module: 'inspiration_lists',
  },
  [RECORD_TYPE.ANNOUNCEMENT_LEVEL]: {
    record_type: RECORD_TYPE.ANNOUNCEMENT_LEVEL,
    store_attr: 'announcement_levels',
    store_module: 'announcement_levels',
  },
  [RECORD_TYPE.LOT]: {
    record_type: RECORD_TYPE.LOT,
    store_attr: 'lots',
    store_module: 'lots',
  },
  [RECORD_TYPE.MENTION]: {
    record_type: RECORD_TYPE.MENTION,
    store_attr: 'mentions',
    store_module: 'mentions',
  },
  [RECORD_TYPE.MESSAGE]: {
    record_type: RECORD_TYPE.MESSAGE,
    store_attr: 'messages',
    store_module: 'messages',
  },
  [RECORD_TYPE.MESSAGE_TRANSFER]: {
    record_type: RECORD_TYPE.MESSAGE_TRANSFER,
    store_attr: 'message_transfers',
    store_module: 'message_transfers',
  },
  [RECORD_TYPE.MILESTONE]: {
    record_type: RECORD_TYPE.MILESTONE,
    store_attr: 'milestones',
    store_module: 'milestones',
  },
  [RECORD_TYPE.MILESTONE_UNIT]: {
    record_type: RECORD_TYPE.MILESTONE_UNIT,
    store_attr: 'milestone_units',
    store_module: 'milestone_units',
  },
  [RECORD_TYPE.NOTIFICATION]: {
    record_type: RECORD_TYPE.NOTIFICATION,
    store_attr: 'notifications',
    store_module: 'notifications',
  },
  [RECORD_TYPE.NOTIFICATION_SUBGROUP]: {
    record_type: RECORD_TYPE.NOTIFICATION_SUBGROUP,
    store_attr: 'notification_subgroups',
    store_module: 'notification_subgroups',
  },
  [RECORD_TYPE.OFFER]: {
    record_type: RECORD_TYPE.OFFER,
    store_attr: 'offers',
    store_module: 'offers',
  },
  [RECORD_TYPE.PARTICIPANT]: {
    record_type: RECORD_TYPE.PARTICIPANT,
    store_attr: 'participants',
    store_module: 'participants',
  },
  [RECORD_TYPE.PHASE]: {
    record_type: RECORD_TYPE.PHASE,
    store_attr: 'phases',
    store_module: 'phases',
  },
  [RECORD_TYPE.PROJECT]: {
    record_type: RECORD_TYPE.PROJECT,
    store_attr: 'projects',
    store_module: 'projects',
  },
  [RECORD_TYPE.PROPOSAL]: {
    record_type: RECORD_TYPE.PROPOSAL,
    store_attr: 'proposals',
    store_module: 'proposals',
  },
  [RECORD_TYPE.PROPOSAL_TEMPLATE]: {
    record_type: RECORD_TYPE.PROPOSAL_TEMPLATE,
    store_attr: 'proposal_templates',
    store_module: 'proposal_templates',
  },
  [RECORD_TYPE.QUESTION]: {
    record_type: RECORD_TYPE.QUESTION,
    store_attr: 'questions',
    store_module: 'questions',
  },
  [RECORD_TYPE.QUESTION_LIST]: {
    record_type: RECORD_TYPE.QUESTION_LIST,
    store_attr: 'question_lists',
    store_module: 'question_lists',
  },
  [RECORD_TYPE.REMINDER]: {
    record_type: RECORD_TYPE.REMINDER,
    store_attr: 'reminders',
    store_module: 'reminders',
  },
  [RECORD_TYPE.SPACE]: {
    record_type: RECORD_TYPE.SPACE,
    store_attr: 'spaces',
    store_module: 'spaces',
  },
  [RECORD_TYPE.PARTNER]: {
    record_type: RECORD_TYPE.PARTNER,
    store_attr: 'partners',
    store_module: 'partners',
  },
  [RECORD_TYPE.COMPANY]: {
    record_type: RECORD_TYPE.COMPANY,
    store_attr: 'companies',
    store_module: 'companies',
  },
  [RECORD_TYPE.SUPERVISOR]: {
    record_type: RECORD_TYPE.SUPERVISOR,
    store_attr: 'supervisors',
    store_module: 'supervisors',
  },
  [RECORD_TYPE.THEME]: {
    record_type: RECORD_TYPE.THEME,
    store_attr: 'themes',
    store_module: 'themes',
  },
  [RECORD_TYPE.TICKET]: {
    record_type: RECORD_TYPE.TICKET,
    store_attr: 'tickets',
    store_module: 'tickets',
  },
  [RECORD_TYPE.TICKET_CATEGORY]: {
    record_type: RECORD_TYPE.TICKET_CATEGORY,
    store_attr: 'ticket_categories',
    store_module: 'ticket_categories',
  },
  [RECORD_TYPE.TASK]: {
    record_type: RECORD_TYPE.TASK,
    store_attr: 'tasks',
    store_module: 'tasks',
  },
  [RECORD_TYPE.TASK_ASSIGNMENT]: {
    record_type: RECORD_TYPE.TASK_ASSIGNMENT,
    store_attr: 'task_assignments',
    store_module: 'task_assignments',
  },
  [RECORD_TYPE.TASK_COMMENT]: {
    record_type: RECORD_TYPE.TASK_COMMENT,
    store_attr: 'task_comments',
    store_module: 'task_comments',
  },
  [RECORD_TYPE.TODO]: {
    record_type: RECORD_TYPE.TODO,
    store_attr: 'todos',
    store_module: 'todos',
  },
  [RECORD_TYPE.TODO_LIST]: {
    record_type: RECORD_TYPE.TODO_LIST,
    store_attr: 'todo_lists',
    store_module: 'todo_lists',
  },
  [RECORD_TYPE.TRIGGER_ACTION]: {
    record_type: RECORD_TYPE.TRIGGER_ACTION,
    store_attr: 'trigger_actions',
    store_module: 'trigger_actions',
  },
  [RECORD_TYPE.UNIT]: {
    record_type: RECORD_TYPE.UNIT,
    store_attr: 'units',
    store_module: 'units',
  },
  [RECORD_TYPE.USER]: {
    record_type: RECORD_TYPE.USER,
    store_attr: 'users',
    store_module: 'users',
  },
  [RECORD_TYPE.SESSION]: {
    record_type: RECORD_TYPE.SESSION,
    store_attr: 'sessions',
    store_module: 'sessions',
  },
  [RECORD_TYPE.TENANT]: {
    record_type: RECORD_TYPE.TENANT,
    store_attr: 'tenants',
    store_module: 'tenants',
  },
  [RECORD_TYPE.LOG_DATA]: {
    record_type: RECORD_TYPE.LOG_DATA,
    store_attr: 'log_datas',
    store_module: 'log_datas',
  },
  [RECORD_TYPE.MARKETPLACE_PARTNER]: {
    record_type: RECORD_TYPE.MARKETPLACE_PARTNER,
    store_attr: 'marketplace_partners',
    store_module: 'marketplace_partners',
  },
});

export default RESOURCES;
